// extracted by mini-css-extract-plugin
export var footerFlexbox = "footer-module--footer-flexbox--1ZpDH";
export var bottomBannerContainer = "footer-module--bottom-banner-container--3Exs5";
export var copyright = "footer-module--copyright--1bZga";
export var tos = "footer-module--tos--2a0nN";
export var links = "footer-module--links--1whV7";
export var pipe = "footer-module--pipe--27a_H";
export var icons = "footer-module--icons--5zyY7";
export var socialIcon = "footer-module--social-icon--yraXu";
export var icon = "footer-module--icon--gNQNo";
export var largerIcon = "footer-module--larger-icon--NrA3m";